import { Directive, ElementRef, Input, OnInit, Output, EventEmitter } from '@angular/core';
import 'intl-tel-input';
import 'jquery';
declare var $: any;

@Directive({
    selector: '[ng2TelInput]'
})
export class Ng2TelInput implements OnInit {
    @Input('ng2TelInput') ng2TelInput: any;

    constructor (private el: ElementRef) {
    }
    ngOnInit() {
        $(this.el.nativeElement).intlTelInput(this.ng2TelInput);
    }
}


// WEBPACK FOOTER //
// ./src/app/ng2-intl-tel-input.ts